import React, { useEffect } from 'react';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';
import FacturasGlobalesStatus from '../../components/FacturasGlobalesStatus';

const mapState = (store) => {
  return store.modulo.fpg.list;
};

const mapActions = (actions) => {
  return actions.modulo.fpg.list;
};

const FacturasGlobalesList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      actions.paginate({
        page: 1,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { filters } = state;

    actions.paginate({
      ...filters,
      ...meta,
    });
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  // COMMENT descomentar cuando se requiera alguna acción sobre el ticket (checkbox)
  // const setSelectedRows = (event) => {
  //   actions.setSelectedRows(event);

  //   !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  // };

  // const getRowSelectionConfig = () => {
  //   const { selectedRowKeys = [] } = props;

  //   return {
  //     type: 'checkbox',
  //     selectedRowKeys,
  //     onChange: setSelectedRows,
  //     getCheckboxProps: (record) => ({
  //       name: record.name,
  //     }),
  //   };
  // };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      // rowSelection={getRowSelectionConfig()}
      onRowClick={onRowClick}
    ></Table>
  );
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
  },
  {
    key: 'emisor_id',
    title: 'Emisor',
    dataIndex: 'emisor_id',
  },
  {
    key: 'grupo',
    title: 'Sucursal',
    dataIndex: 'grupo',
    align: 'center',
  },
  {
    key: 'tickets',
    title: 'Tickets',
    dataIndex: 'tickets',
    align: 'center',
  },
  {
    key: 'forma_de_pago',
    title: 'Forma Pago',
    dataIndex: 'forma_de_pago',
    align: 'center',
  },
  {
    key: 'metodo_de_pago',
    title: 'Método Pago',
    dataIndex: 'metodo_de_pago',
    align: 'center',
  },
  {
    key: 'subtotal',
    title: 'Subtotal',
    dataIndex: 'subtotal',
    align: 'right',
  },
  {
    key: 'descuento',
    title: 'Descuento',
    dataIndex: 'descuento',
    align: 'right',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'right',
  },
  {
    key: 'cfdi_uuid',
    title: 'Cfdi Uuid',
    dataIndex: 'cfdi_uuid',
    align: 'center',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <FacturasGlobalesStatus item={{ ...item }} />,
  },
];

export default FacturasGlobalesList;
